import { toast } from "react-toastify";

export const showToast = (message: string) => {
  toast.dismiss();
  toast.success(message);
};

export const showWarning = (message: string) => {
  toast.dismiss();
  toast.warn(message || "Something went wrong");
};

export const showError = (message: string) => {
  toast.dismiss();

  if (message === "IBAN_MUST_END_WITH_21_NUMBERS") {
    message = "IBAN must end with 21 numeric digits.";
  }

  toast.error(message || "Something went wrong");
};

